import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

export const RejectedMarkIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
	const height = 17;
	const width = 16;
	return (
		<SvgIcon
			className='rejected-mark-icon'
			fill='none'
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			width={width}
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8 2.1a6.407 6.407 0 0 0-6.4 6.4c0 3.529 2.872 6.4 6.4 6.4 3.53 0 6.4-2.871 6.4-6.4 0-3.529-2.87-6.4-6.4-6.4m0 14.4c-4.41 0-8-3.589-8-8s3.59-8 8-8c4.412 0 8 3.589 8 8s-3.588 8-8 8'
				fill='currentColor'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M12 5.702 10.8 4.5 8 7.298 5.202 4.5 4 5.702 6.8 8.5 4 11.298 5.202 12.5 8 9.702l2.8 2.798 1.2-1.202L9.202 8.5l2.799-2.798Z'
				fill='currentColor'
			/>
		</SvgIcon>
	);
};
